var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"calculator",attrs:{"id":"calculator"}},[_c('calculator-content')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }